<template>
  <div class="data-item">
    <div :class="['data-item-content']">
      <div class="data-item-list">
        <img v-if="term === 'crowd'" class="data-item-list-img" src="../imgs/crowd.png" alt="">
        <img v-if="term === 'match'" class="data-item-list-img" src="../imgs/match.png" alt="">
        <img v-if="term === 'splitting'" class="data-item-list-img" src="../imgs/splitting.png" alt="">
        <img v-if="term === 'system'" class="data-item-list-img" src="../imgs/system.png" alt="">
        <template v-if="data?.length > 0">
          <custom-scrollbar>
            <div
              v-for="(v, idx) in data" 
              :key="idx" 
              class="data-item-list-item" 
            >
              <div :class="['data-item-list-item-title', term === 'system' ? '!text-[var(--color-warning)]' : '']">
                {{ isNull(v?.value) ? '--' : v?.value }}
              </div>
  
              <div class="data-item-list-item-value">
                {{ isNull(v?.name) ? '--' : v?.name }}
              </div>
            </div>
          </custom-scrollbar>
        </template>
        <div v-else class="not-data">
          请点击右上角“管理”按钮，添加需查看的统计数据
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { CustomScrollbar } from '@vue3/components';
import { IStatisticsItem } from '@core/main/types';
import { isNull } from '@core/tools';
import { PropType } from 'vue';

defineProps({
  term: {
    type: String as PropType<'crowd' | 'match' | 'splitting' | 'system'>,
    default: '',
  },
  data: {
    type: Array as PropType<IStatisticsItem[]>,
    default: () => [{}],
  },
});
</script>

<style lang="scss" scoped src="../style/data-statistics.scss"></style>
